export const APPOINTMENT_LOCATION_VALUES = ['Clinica', 'Domicilio', 'Hospitalar'] as const;

export type AppointmentLocation = (typeof APPOINTMENT_LOCATION_VALUES)[number];

const NORMALIZED_TO_CANONICAL: Record<string, AppointmentLocation> = {
  clinica: 'Clinica',
  domicilio: 'Domicilio',
  hospitalar: 'Hospitalar',
};

export function normalizeAppointmentLocation(value: unknown): AppointmentLocation | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  return NORMALIZED_TO_CANONICAL[normalized] ?? null;
}

export function isAppointmentLocation(value: unknown): value is AppointmentLocation {
  return normalizeAppointmentLocation(value) !== null;
}

export function formatAppointmentLocation(value: unknown): string {
  const normalized = normalizeAppointmentLocation(value);

  if (normalized === 'Clinica') {
    return 'Clínica';
  }

  if (normalized === 'Domicilio') {
    return 'Domicílio';
  }

  if (normalized === 'Hospitalar') {
    return 'Hospitalar';
  }

  return 'Local inválido';
}

export function describeAppointmentLocationIssue(value: unknown): string | null {
  if (value == null) {
    return 'Local ausente';
  }

  if (typeof value !== 'string') {
    return 'Local inválido';
  }

  if (!value.trim()) {
    return 'Local ausente';
  }

  if (!normalizeAppointmentLocation(value)) {
    return `Local inválido: ${value.trim()}`;
  }

  return null;
}
